import { LastMinuteRiskAnalysis } from "@/services/backend/rlt/work-orders/types/last-minute-risk-analysis";
import {
  updateRltLMRACache,
  useRltLMRAResetReferenceNumberMutation,
  useRltLMRAPatchMutation,
} from "@/services/backend/rlt/work-orders/api/lmra-api";
import { ReferenceNumberField } from "@/services/backend/documents/components/reference-number-field";
import { Card, CardContent } from "@/shared/components/ui/card";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { ErrValidationFailedContextProvider } from "@/shared/lib/errors/err-validation-failed-context";

/**
 * LMRAReferenceNumberCard edits the reference number of a last minute risk
 * analysis. Renders nothing if the analysis has no number.
 *
 * The analysis is a document of its own, rendered inside the page of its
 * work order. Its errors get a scope of their own, so they do not collide
 * with the work order's "referenceNumber".
 */
export function LMRAReferenceNumberCard({
  lmra,
  disabled = false,
}: {
  lmra: LastMinuteRiskAnalysis;
  disabled?: boolean;
}) {
  const patchReferenceNumber = useRltLMRAPatchMutation();
  const resetReferenceNumber = useRltLMRAResetReferenceNumberMutation();

  if (!lmra.referenceNumber) {
    return null;
  }

  return (
    <Card>
      <CardContent>
        <ErrValidationFailedContextProvider>
          <ReferenceNumberField
            data={lmra}
            updateCache={updateRltLMRACache}
            patchMutation={patchReferenceNumber}
            resetMutation={resetReferenceNumber}
            disabled={disabled || isImmutable(lmra)}
          />
        </ErrValidationFailedContextProvider>
      </CardContent>
    </Card>
  );
}
